import React, { useEffect, useState } from "react";
import axiosClient, { getData, putData } from "../../global/Globalapi";
import Inputfield from "./Inputfield";
import { toast } from "react-toastify";
import Productmasterimg from "../MENU/PRODUCT/Product/Productmasterimg";

// const Step3 = ({
//   selectedvalues,
//   combos,
//   setCombos,
//   Features,
//   newproductid,
//   onSaveComplete,
//   hasVariant,
// }) => {
//   const [variantspecattropts, setvaraintspecattropts] = useState([]);
//   const variantattributes = selectedvalues.filter(
//     (item) => item.Attribute_Category === "Variant_Deterministic"
//   );

//   useEffect(() => {
//     console.log("hasvariant prop in Step3:", hasVariant);
//   }, [hasVariant]);

//   const generateCombinations = (attributes) => {
//     if (!attributes || attributes.length === 0) return [];
//     return attributes.reduce((acc, attr) => {
//       const result = [];
//       if (!acc || acc.length === 0) {
//         // For the first attribute, create initial combinations
//         attr.values.forEach((val) => {
//           result.push([{ value: val, id: attr.ID }]);
//         });
//       } else {
//         // For subsequent attributes, combine with existing prefixes
//         acc.forEach((prefix) => {
//           attr.values.forEach((val) => {
//             result.push([...prefix, { value: val, id: attr.ID }]);
//           });
//         });
//       }
//       return result;
//     }, []);
//   };

//   const fetchOptions = async () => {
//     try {
//       const variantspecific = Features.filter(
//         (f) => f.Attribute_Category === "Variant_Specific"
//       );
//       const variantspecificPromises = variantspecific.map(async (feature) => {
//         const id = feature.id;
//         const res = await getData(`/productoption/${id}`);
//         return { feature, options: res.data };
//       });
//       const variantspecificResults = await Promise.all(variantspecificPromises);
//       setvaraintspecattropts(
//         variantspecificResults.map(({ feature, options }) => ({
//           ...feature,
//           options,
//         }))
//       );
//     } catch (error) {
//       console.error("Error fetching options:", error);
//     }
//   };

//   useEffect(() => {
//     fetchOptions();
//   }, [Features]);

//   useEffect(() => {
//     const newCombos = generateCombinations(variantattributes).map((combo) => {
//       const comboValues = combo.map((item) => item.value);
//       const comboIds = combo.map((item) => item.id);
//       const comboKey = comboValues.join("|");
//       const existingCombo = combos.find((c) => c.combo.join("|") === comboKey);
//       return {
//         combo: comboValues,
//         ids: comboIds,
//         stock: existingCombo ? existingCombo.stock : "",
//         price: existingCombo ? existingCombo.price : "",
//         images: existingCombo ? existingCombo.images || [] : [],
//         variantSpecificValues: existingCombo
//           ? existingCombo.variantSpecificValues || []
//           : [],
//       };
//     });
//     setCombos(newCombos);
//   }, [selectedvalues]);

//   useEffect(() => {
//     console.log("Combos updated in state:", combos);
//   }, [combos]);

//   const handleChange = (index, field, value) => {
//     const updated = [...combos];
//     updated[index][field] = value;
//     setCombos(updated);
//   };

//   const handleComboImagesUpdate = (comboIndex, updatedImages) => {
//     const updatedCombos = [...combos];
//     updatedCombos[comboIndex].images = updatedImages;
//     setCombos(updatedCombos);
//   };

//   const removeCombo = (index) => {
//     setCombos(combos.filter((_, i) => i !== index));
//   };

//   const handleVariantSpecificChange = (comboIndex, attributeData) => {
//     const updatedCombos = [...combos];
//     const targetCombo = updatedCombos[comboIndex];

//     // Ensure the variantSpecificValues array exists
//     if (!targetCombo.variantSpecificValues) {
//       targetCombo.variantSpecificValues = [];
//     }

//     // Check if the attribute being changed is already in the array
//     const existingAttrIndex = targetCombo.variantSpecificValues.findIndex(
//       (attr) => attr.ide === attributeData.ide
//     );

//     if (existingAttrIndex > -1) {
//       // If it exists, update it
//       targetCombo.variantSpecificValues[existingAttrIndex] = attributeData;
//     } else {
//       // If it's a new attribute for this variant, add it
//       targetCombo.variantSpecificValues.push(attributeData);
//     }

//     setCombos(updatedCombos);
//   };

//   const handleSaveVariants = async () => {
//     if (!newproductid) {
//       toast.error("Parent Product ID is missing.");
//       return;
//     }

//     const formDataToSend = new FormData();
//     formDataToSend.append("newproductid", newproductid);

//     const variantsDataForJson = [];

//     combos.forEach((variant) => {
//       const imageMetadata = [];
//       if (variant.images && variant.images.length > 0) {
//         variant.images.forEach((image, imgIndex) => {
//           if (image.file) {
//             formDataToSend.append("variant_images", image.file);
//             imageMetadata.push({
//               originalName: image.file.name, // <-- ADD THIS LINE
//               description: image.description || "",
//               displayOrder: image.displayOrder || imgIndex + 1,
//             });
//           }
//         });
//       }
//       const transformedSpecificAttributes = (
//         variant.variantSpecificValues || []
//       ).map((attr) => {
//         let finalValues = [];

//         // Check for the specific, deeply-nested structure from the screenshot
//         if (
//           Array.isArray(attr.values) &&
//           attr.values.length > 0 &&
//           typeof attr.values[0] === "object" &&
//           attr.values[0] !== null &&
//           Array.isArray(attr.values[0].values)
//         ) {
//           // If it matches, we've found our data! It's in the nested 'values' property.
//           finalValues = attr.values[0].values;
//         } else {
//           // This is a fallback for simpler inputs (like radio buttons or text fields)
//           // It handles arrays of strings or arrays of {value, label} objects.
//           const valuesAsArray = Array.isArray(attr.values)
//             ? attr.values.flat()
//             : [attr.values];
//           finalValues = valuesAsArray.map((item) =>
//             typeof item === "object" &&
//             item !== null &&
//             item.hasOwnProperty("value")
//               ? item.value
//               : item
//           );
//         }

//         // Return the attribute with the clean, simple array of values
//         return {
//           ...attr,
//           values: finalValues.filter((v) => v !== null && v !== undefined),
//         };
//       });

//       // 🔑 Normalize combo before pushing
//       // const normalizedCombo = Object.values()
//       //     .map(v => v.value)
//       //     .sort((a, b) => a.localeCompare(b))
//       //     .join(',');
//       const normalizedCombo = [...variant.combo].sort((a, b) =>
//         a.localeCompare(b)
//       );

//       console.log({ normalizedCombo });

//       variantsDataForJson.push({
//         combo: normalizedCombo,
//         stock: variant.stock || 0,
//         price: variant.price || 0,
//         specificAttributes: transformedSpecificAttributes,
//         image_metadata: imageMetadata,
//       });
//     });

//     formDataToSend.append("variants_data", JSON.stringify(variantsDataForJson));

//     const baseAttributes = selectedvalues
//       .filter(
//         (item) =>
//           item.Attribute_Category === "Common" ||
//           item.Attribute_Category === "Variant_Deterministic"
//       )
//       .map((item) => ({
//         Comp_Map_Id: item.ide,
//         Label: item.label,
//         Option_Type: item.Attribute_Type,
//         Options: Array.isArray(item.values) ? item.values.join(",") : "",
//       }));
//     formDataToSend.append(
//       "baseAttributes_data",
//       JSON.stringify(baseAttributes)
//     );

//     toast.info("Saving variants and images...");
//     try {
//       await axiosClient.post(
//         "/api/product/add_variants_with_options",
//         formDataToSend,
//         { headers: { "Content-Type": "multipart/form-data" } }
//       );

//       // await putData(`/product_price/${newproductid}`, { hasVariant: true });

//       toast.success("Variants and images saved successfully!");
//       if (onSaveComplete) onSaveComplete();
//     } catch (error) {
//       const errorMessage =
//         error.response?.data?.message ||
//         "An error occurred while saving variants.";
//       toast.error(errorMessage);
//       console.error("Failed to save variants and options:", error);
//     }
//   };

//   return (
//     <div className="p-6">
//       <h2 className="text-xl font-semibold text-gray-800 mb-4">
//         Variant Combinations
//       </h2>
//       <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
//         {combos.map((item, index) => (
//           <div
//             key={item.combo.join("|")}
//             className="relative bg-white border border-gray-200 rounded-2xl p-5 shadow-md transition-all hover:shadow-lg"
//           >
//             <button
//               onClick={() => removeCombo(index)}
//               className="absolute top-3 right-3 text-gray-400 hover:text-red-600"
//               title="Remove"
//             >
//               X
//             </button>

//             <div className="flex flex-wrap gap-2 mb-4">
//               {item.combo.map((val, i) => (
//                 <span
//                   key={i}
//                   className="bg-blue-500 text-white text-xs font-semibold px-3 py-1 rounded-full shadow-sm"
//                 >
//                   {val}
//                 </span>
//               ))}
//             </div>

//             <div className="space-y-4">
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                   Stock
//                 </label>
//                 <input
//                   type="number"
//                   value={item.stock}
//                   onChange={(e) => handleChange(index, "stock", e.target.value)}
//                   className="w-full rounded-lg border border-gray-300 px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
//                   placeholder="Enter stock"
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                   Selling Price
//                 </label>
//                 <input
//                   type="number"
//                   value={item.price}
//                   onChange={(e) => handleChange(index, "price", e.target.value)}
//                   className="w-full rounded-lg border border-gray-300 px-4 py-2 focus:ring-2 focus:ring-green-500 focus:outline-none"
//                   placeholder="Enter price"
//                 />
//               </div>

//               {/* <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                   Variant Images
//                 </label>
//                 <div className="p-2 border rounded-lg bg-gray-50">
//                   <Productmasterimg
//                     key={`img-${item.combo.join("-")}`}
//                     productId={null}
//                     initialImages={item.images}
//                     onImagesUpdate={(updatedImages) =>
//                       handleComboImagesUpdate(index, updatedImages)
//                     }
//                   />
//                 </div>
//               </div> */}
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                   Variant Images
//                 </label>

//                 <div className="p-2 border rounded-lg bg-gray-50">
//                   {/* SCALE DOWN Productmasterimg UI WITHOUT SCROLL */}
//                   <div
//                     className="origin-top-left"
//                     style={{
//                       transform: "scale(0.75)", // adjust size 0.60–0.90 as needed
//                       transformOrigin: "top left",
//                       width: "133%", // fixes width shrinking from scaling
//                     }}
//                   >
//                     <Productmasterimg
//                       key={`img-${item.combo.join("-")}`}
//                       productId={null}
//                       initialImages={item.images}
//                       onImagesUpdate={(updatedImages) =>
//                         handleComboImagesUpdate(index, updatedImages)
//                       }
//                     />
//                   </div>
//                 </div>
//               </div>

//               {variantspecattropts
//                 .filter((attr) => item.ids.includes(attr.parent_variant_id))
//                 .map((attr) => (
//                   <Inputfield
//                     key={attr.attribute_id}
//                     type={attr.Attribute_Type}
//                     label={attr.compName}
//                     name={attr.attribute_id}
//                     options={attr.options?.map((opt) => opt.option) || []}
//                     selectedValues={
//                       item.variantSpecificValues?.find((a) => a.ide === attr.id)
//                         ?.values || []
//                     }
//                     setSelectedValues={(selectedOptions) =>
//                       handleVariantSpecificChange(index, {
//                         ide: attr.id,
//                         label: attr.compName,
//                         values: selectedOptions, // selectedOptions is the value from Inputfield
//                         Attribute_Type: attr.Attribute_Type,
//                       })
//                     }
//                     required={true}
//                     Attribute_Category={attr.Attribute_Category}
//                     parent_variant_id={attr.parent_variant_id}
//                     Attribute_Type={attr.Attribute_Type}
//                     ide={attr.id}
//                   />
//                 ))}
//             </div>
//           </div>
//         ))}
//       </div>
//       <div className="mt-8 flex justify-end">
//         <button
//           onClick={handleSaveVariants}
//           className="px-6 py-2 bg-green-600 text-white font-semibold rounded-lg shadow-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-75"
//         >
//           Save Variants
//         </button>
//       </div>
//     </div>
//   );
// };
const Step3 = ({
  selectedvalues,
  combos,
  setCombos,
  Features,
  newproductid,
  onSaveComplete,
  hasVariant,
}) => {
  const [variantspecattropts, setvaraintspecattropts] = useState([]);
  const [openImagesByKey, setOpenImagesByKey] = useState({});
  const [openOptionsByKey, setOpenOptionsByKey] = useState({});
  const [selectedByKey, setSelectedByKey] = useState({});
  const variantattributes = selectedvalues.filter(
    (item) => item.Attribute_Category === "Variant_Deterministic"
  );

  useEffect(() => {
    console.log("hasvariant prop in Step3:", hasVariant);
  }, [hasVariant]);

  const generateCombinations = (attributes) => {
    if (!attributes || attributes.length === 0) return [];
    return attributes.reduce((acc, attr) => {
      const result = [];
      if (!acc || acc.length === 0) {
        // For the first attribute, create initial combinations
        attr.values.forEach((val) => {
          result.push([{ value: val, id: attr.ID }]);
        });
      } else {
        // For subsequent attributes, combine with existing prefixes
        acc.forEach((prefix) => {
          attr.values.forEach((val) => {
            result.push([...prefix, { value: val, id: attr.ID }]);
          });
        });
      }
      return result;
    }, []);
  };

  const fetchOptions = async () => {
    try {
      const variantspecific = Features.filter(
        (f) => f.Attribute_Category === "Variant_Specific"
      );
      const variantspecificPromises = variantspecific.map(async (feature) => {
        const id = feature.id;
        const res = await getData(`/productoption/${id}`);
        return { feature, options: res.data };
      });
      const variantspecificResults = await Promise.all(variantspecificPromises);
      setvaraintspecattropts(
        variantspecificResults.map(({ feature, options }) => ({
          ...feature,
          options,
        }))
      );
    } catch (error) {
      console.error("Error fetching options:", error);
    }
  };

  useEffect(() => {
    fetchOptions();
  }, [Features]);

  useEffect(() => {
    const newCombos = generateCombinations(variantattributes).map((combo) => {
      const comboValues = combo.map((item) => item.value);
      const comboIds = combo.map((item) => item.id);
      const comboKey = comboValues.join("|");
      const existingCombo = combos.find((c) => c.combo.join("|") === comboKey);
      return {
        combo: comboValues,
        ids: comboIds,
        stock: existingCombo ? existingCombo.stock : "",
        price: existingCombo ? existingCombo.price : "",
        images: existingCombo ? existingCombo.images || [] : [],
        variantSpecificValues: existingCombo
          ? existingCombo.variantSpecificValues || []
          : [],
      };
    });
    setCombos(newCombos);
  }, [selectedvalues]);

  useEffect(() => {
    console.log("Combos updated in state:", combos);
  }, [combos]);

  useEffect(() => {
    // Keep toggles in sync when combos regenerate
    const validKeys = new Set((combos || []).map((c) => (c.combo || []).join("|")));

    setOpenImagesByKey((prev) => {
      const next = {};
      Object.keys(prev || {}).forEach((k) => {
        if (validKeys.has(k)) next[k] = prev[k];
      });
      return next;
    });

    setOpenOptionsByKey((prev) => {
      const next = {};
      Object.keys(prev || {}).forEach((k) => {
        if (validKeys.has(k)) next[k] = prev[k];
      });
      return next;
    });

    setSelectedByKey((prev) => {
      const next = {};
      Object.keys(prev || {}).forEach((k) => {
        if (validKeys.has(k)) next[k] = prev[k];
      });
      return next;
    });
  }, [combos]);

  const totalCombos = (combos || []).length;
  const selectedCount = Object.values(selectedByKey || {}).filter(Boolean).length;
  const isAllSelected = totalCombos > 0 && selectedCount === totalCombos;

  const setAllSelected = (checked) => {
    if (!checked) {
      setSelectedByKey({});
      return;
    }

    const next = {};
    (combos || []).forEach((c) => {
      const key = (c.combo || []).join("|");
      if (key) next[key] = true;
    });
    setSelectedByKey(next);
  };

  const toggleSelected = (key) => {
    setSelectedByKey((prev) => ({ ...prev, [key]: !prev?.[key] }));
  };

  const handleChange = (index, field, value) => {
    const updated = [...combos];
    const changedKey = (updated[index]?.combo || []).join("|");

    // Default: update only the current row
    updated[index][field] = value;

    // Bulk apply only for stock/price and only when selection is active
    const selectionActive = (selectedCount > 0 || isAllSelected) && (field === "stock" || field === "price");
    const rowIsSelected = isAllSelected || !!selectedByKey?.[changedKey];

    if (selectionActive && rowIsSelected) {
      updated.forEach((c, i) => {
        const k = (c.combo || []).join("|");
        const shouldUpdate = isAllSelected || !!selectedByKey?.[k];
        if (shouldUpdate) updated[i][field] = value;
      });
    }

    setCombos(updated);
  };

  const handleComboImagesUpdate = (comboIndex, updatedImages) => {
    const updatedCombos = [...combos];
    updatedCombos[comboIndex].images = updatedImages;
    setCombos(updatedCombos);
  };

  const removeCombo = (index) => {
    setCombos(combos.filter((_, i) => i !== index));
  };

  const toggleImages = (key) => {
    setOpenImagesByKey((prev) => ({ ...prev, [key]: !prev?.[key] }));
  };

  const toggleOptions = (key) => {
    setOpenOptionsByKey((prev) => ({ ...prev, [key]: !prev?.[key] }));
  };

  const handleVariantSpecificChange = (comboIndex, attributeData) => {
    const updatedCombos = [...combos];
    const targetCombo = updatedCombos[comboIndex];

    // Ensure the variantSpecificValues array exists
    if (!targetCombo.variantSpecificValues) {
      targetCombo.variantSpecificValues = [];
    }

    // Check if the attribute being changed is already in the array
    const existingAttrIndex = targetCombo.variantSpecificValues.findIndex(
      (attr) => attr.ide === attributeData.ide
    );

    if (existingAttrIndex > -1) {
      // If it exists, update it
      targetCombo.variantSpecificValues[existingAttrIndex] = attributeData;
    } else {
      // If it's a new attribute for this variant, add it
      targetCombo.variantSpecificValues.push(attributeData);
    }

    setCombos(updatedCombos);
  };

  const handleSaveVariants = async () => {
    if (!newproductid) {
      toast.error("Parent Product ID is missing.");
      return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append("newproductid", newproductid);

    const variantsDataForJson = [];

    combos.forEach((variant) => {
      const imageMetadata = [];
      if (variant.images && variant.images.length > 0) {
        variant.images.forEach((image, imgIndex) => {
          if (image.file) {
            formDataToSend.append("variant_images", image.file);
            imageMetadata.push({
              originalName: image.file.name, // <-- ADD THIS LINE
              description: image.description || "",
              displayOrder: image.displayOrder || imgIndex + 1,
            });
          }
        });
      }
      const transformedSpecificAttributes = (
        variant.variantSpecificValues || []
      ).map((attr) => {
        let finalValues = [];

        // Check for the specific, deeply-nested structure from the screenshot
        if (
          Array.isArray(attr.values) &&
          attr.values.length > 0 &&
          typeof attr.values[0] === "object" &&
          attr.values[0] !== null &&
          Array.isArray(attr.values[0].values)
        ) {
          // If it matches, we've found our data! It's in the nested 'values' property.
          finalValues = attr.values[0].values;
        } else {
          // This is a fallback for simpler inputs (like radio buttons or text fields)
          // It handles arrays of strings or arrays of {value, label} objects.
          const valuesAsArray = Array.isArray(attr.values)
            ? attr.values.flat()
            : [attr.values];
          finalValues = valuesAsArray.map((item) =>
            typeof item === "object" &&
            item !== null &&
            item.hasOwnProperty("value")
              ? item.value
              : item
          );
        }

        // Return the attribute with the clean, simple array of values
        return {
          ...attr,
          values: finalValues.filter((v) => v !== null && v !== undefined),
        };
      });

      // 🔑 Normalize combo before pushing
      // const normalizedCombo = Object.values()
      //     .map(v => v.value)
      //     .sort((a, b) => a.localeCompare(b))
      //     .join(',');
      const normalizedCombo = [...variant.combo].sort((a, b) =>
        a.localeCompare(b)
      );

      console.log({ normalizedCombo });

      variantsDataForJson.push({
        combo: normalizedCombo,
        stock: variant.stock || 0,
        price: variant.price || 0,
        specificAttributes: transformedSpecificAttributes,
        image_metadata: imageMetadata,
      });
    });

    formDataToSend.append("variants_data", JSON.stringify(variantsDataForJson));

    const baseAttributes = selectedvalues
      .filter(
        (item) =>
          item.Attribute_Category === "Common" ||
          item.Attribute_Category === "Variant_Deterministic"
      )
      .map((item) => ({
        Comp_Map_Id: item.ide,
        Label: item.label,
        Option_Type: item.Attribute_Type,
        Options: Array.isArray(item.values) ? item.values.join(",") : "",
      }));
    formDataToSend.append(
      "baseAttributes_data",
      JSON.stringify(baseAttributes)
    );

    toast.info("Saving variants and images...");
    try {
      await axiosClient.post(
        "/api/product/add_variants_with_options",
        formDataToSend,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      // await putData(`/product_price/${newproductid}`, { hasVariant: true });

      toast.success("Variants and images saved successfully!");
      if (onSaveComplete) onSaveComplete();
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        "An error occurred while saving variants.";
      toast.error(errorMessage);
      console.error("Failed to save variants and options:", error);
    }
  };

  return (
    <div className="p-6">
      <h2 className="text-xl font-semibold text-gray-800 mb-4">
        Variant Combinations
      </h2>
      <div className="flex flex-wrap items-center justify-between gap-3 mb-3">
        <div className="text-sm text-gray-700">
          Selected: <span className="font-semibold">{selectedCount}</span> / {totalCombos}
        </div>
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => setAllSelected(true)}
            className="px-3 py-2 text-xs font-semibold rounded-md border border-gray-300 hover:bg-gray-50"
          >
            Select all
          </button>
          <button
            type="button"
            onClick={() => setAllSelected(false)}
            className="px-3 py-2 text-xs font-semibold rounded-md border border-gray-300 hover:bg-gray-50"
          >
            Clear
          </button>
        </div>
      </div>
      <div className="bg-white border border-gray-200 rounded-2xl shadow-sm overflow-hidden">
        {/* Header (desktop/tablet) */}
        <div className="hidden md:grid grid-cols-[44px_1fr_120px_140px_240px_60px] gap-3 px-4 py-4 bg-gray-50 border-b text-sm font-bold text-gray-700">
          <div className="flex items-center">
            <input
              type="checkbox"
              checked={isAllSelected}
              onChange={(e) => setAllSelected(e.target.checked)}
              className="h-4 w-4"
              title="Select all variants"
            />
          </div>
          <div>Variant</div>
          <div>Stock</div>
          <div>Price</div>
          <div>Images / Options</div>
          <div className="text-right">&nbsp;</div>
        </div>

        <div className="divide-y">
          {combos.map((item, index) => {
            const comboKey = (item.combo || []).join("|");
            const imagesCount = Array.isArray(item.images) ? item.images.length : 0;
            const optionAttrs = variantspecattropts.filter((attr) =>
              item.ids.includes(attr.parent_variant_id)
            );
            const isSelected = !!selectedByKey?.[comboKey] || isAllSelected;

            return (
              <div key={comboKey} className="px-4 py-4">
                <div className="grid grid-cols-1 md:grid-cols-[44px_1fr_120px_140px_240px_60px] gap-3 items-start">
                  {/* Select (desktop) */}
                  <div className="hidden md:flex items-start pt-1">
                    <input
                      type="checkbox"
                      checked={isSelected}
                      onChange={() => toggleSelected(comboKey)}
                      className="h-4 w-4"
                      title="Select this variant"
                    />
                  </div>

                  {/* Variant chips */}
                  <div className="min-w-0">
                    <div className="md:hidden text-sm font-bold text-gray-700 mb-1">
                      Variant
                    </div>
                    {/* Select (mobile) */}
                    <div className="md:hidden flex items-center gap-2 mb-2">
                      <input
                        type="checkbox"
                        checked={isSelected}
                        onChange={() => toggleSelected(comboKey)}
                        className="h-4 w-4"
                        title="Select this variant"
                      />
                      <span className="text-xs font-semibold text-gray-600">Select</span>
                    </div>
                    <div className="flex flex-wrap gap-1">
                      {(item.combo || []).map((val, i) => (
                        <span
                          key={i}
                          className="bg-blue-600 text-white text-sm font-semibold px-3 py-1 rounded-full"
                          title={val}
                        >
                          {val}
                        </span>
                      ))}
                    </div>
                  </div>

                  {/* Stock */}
                  <div>
                    <label className="md:hidden text-sm font-bold text-gray-700">
                      Stock
                    </label>
                    <input
                      type="number"
                      value={item.stock}
                      onChange={(e) => handleChange(index, "stock", e.target.value)}
                      className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
                      placeholder="Stock"
                    />
                  </div>

                  {/* Price */}
                  <div>
                    <label className="md:hidden text-sm font-bold text-gray-700">
                      Selling Price
                    </label>
                    <input
                      type="number"
                      value={item.price}
                      onChange={(e) => handleChange(index, "price", e.target.value)}
                      className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:ring-2 focus:ring-green-500 focus:outline-none"
                      placeholder="Price"
                    />
                  </div>

                  {/* Images / options actions */}
                  <div>
                    <div className="md:hidden text-sm font-bold text-gray-700 mb-1">
                      Images / Options
                    </div>
                    <div className="flex flex-wrap items-center gap-2">
                      <button
                        type="button"
                        onClick={() => toggleImages(comboKey)}
                        className="px-3 py-2 text-xs font-semibold rounded-md border border-gray-300 hover:bg-gray-500"
                      >
                        {openImagesByKey?.[comboKey] ? "Hide" : "Edit"} Images ({imagesCount})
                      </button>
                      {optionAttrs.length > 0 && (
                        <button
                          type="button"
                          onClick={() => toggleOptions(comboKey)}
                          className="px-3 py-2 text-xs font-semibold rounded-md border border-gray-300 hover:bg-gray-50"
                        >
                          {openOptionsByKey?.[comboKey] ? "Hide" : "Edit"} Options
                        </button>
                      )}
                    </div>
                  </div>

                  {/* Remove */}
                  <div className="flex md:justify-end">
                    <button
                      type="button"
                      onClick={() => removeCombo(index)}
                      className="px-3 py-2 text-xs font-semibold rounded-md text-red-600 border border-red-200 hover:bg-red-50"
                      title="Remove"
                    >
                      Remove
                    </button>
                  </div>
                </div>

                {/* Collapsible Images editor */}
                {openImagesByKey?.[comboKey] && (
                  <div className="mt-3 p-2 border rounded-lg bg-gray-50 overflow-x-auto">
                    <div
                      className="origin-top-left"
                      style={{
                        transform: "scale(0.75)",
                        transformOrigin: "top left",
                        width: "133%",
                      }}
                    >
                      <Productmasterimg
                        key={`img-${(item.combo || []).join("-")}`}
                        productId={null}
                        initialImages={item.images}
                        onImagesUpdate={(updatedImages) =>
                          handleComboImagesUpdate(index, updatedImages)
                        }
                      />
                    </div>
                  </div>
                )}

                {/* Collapsible Variant-Specific options */}
                {openOptionsByKey?.[comboKey] && optionAttrs.length > 0 && (
                  <div className="mt-3 p-3 border rounded-lg bg-white">
                    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                      {optionAttrs.map((attr) => (
                        <Inputfield
                          key={attr.attribute_id}
                          type={attr.Attribute_Type}
                          label={attr.compName}
                          name={attr.attribute_id}
                          options={attr.options?.map((opt) => opt.option) || []}
                          selectedValues={
                            item.variantSpecificValues?.find(
                              (a) => a.ide === attr.id
                            )?.values || []
                          }
                          setSelectedValues={(selectedOptions) =>
                            handleVariantSpecificChange(index, {
                              ide: attr.id,
                              label: attr.compName,
                              values: selectedOptions,
                              Attribute_Type: attr.Attribute_Type,
                            })
                          }
                          required={true}
                          Attribute_Category={attr.Attribute_Category}
                          parent_variant_id={attr.parent_variant_id}
                          Attribute_Type={attr.Attribute_Type}
                          ide={attr.id}
                        />
                      ))}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
      <div className="mt-8 flex justify-end">
        <button
          onClick={handleSaveVariants}
          className="px-6 py-2 bg-green-600 text-white font-semibold rounded-lg shadow-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-75"
        >
          Save Variants
        </button>
      </div>
    </div>
  );
};
export default Step3;
